import { AuthContext } from 'contexts/AuthProvider';
import React from 'react';

export function useAuth() {
  return React.useContext(AuthContext);
}
